module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/foreword"
    }
  }, [_vm._v("Foreword, by Paula Schermerhorn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgement"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_vm._v("Introduction and Information about Fort Worth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" I. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMETERIES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oakwood Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pioneers Rest Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mount Olivet Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rose Hill Memorial Park")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parker Memorial Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Veal Station Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lost Cemetery of Infants in Arlington")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" II. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALKED")]), _vm._v("-A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOUT")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUNTINGS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miss Molly’s Bed and Breakfast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Log Cabin Village")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" III. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TOCKYARDS")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REA")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#ch3.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fort Worth Stockyards")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" IV. E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VEN")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOST")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TORIES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch4.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scott Theatre")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch4.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Texas White House Bed and Breakfast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch4.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Del Frisco’s Steakhouse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch4.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Texas Wesleyan University Nicholas Martin Hall, Ann Waggoner Fine Arts Building")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch4.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peters Bros. Hats")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch4.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Schoonover Mansion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch4.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jamba Juice in the Jett Building")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" V. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOSED")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BUT")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TILL THE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUNTING")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greene’s Antiques/ Barbers Book Store")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Former Swift Meatpacking Office/ Spaghetti Warehouse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" VI. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OME")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EOPLE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AY")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUNTED")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BUT")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEY")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AY")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stockyards Hotel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jett Building")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thistle Hill")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" VII. A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RLINGTON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUNTINGS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#ch7.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Haunted Places in Arlington: River Legacy Park, Hell’s Gate, the Screaming Bridge, Six Flags Over Texas and Crystal Canyon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#ch7.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bird’s Fort")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" VIII. O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("THER")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOSTS")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORTH A")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTION IN AND AROUND")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORT")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORTH")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("North Richland Hill’s Knob Hill")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Granbury Opera House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Farr Best Theater in Mansfield")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Baker Hotel in Mineral Wells")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/wrapping",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wrapping It All Up")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author and Photographer")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2b12612","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content.vue
// module id = 66
// module chunks = 0